import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";



export const RegisterStyle = StyleSheet.create({
    imgView: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',

    },
    buttonStyle: {
        borderRadius: 10,
        paddingHorizontal: 10,
    },
    titleStyle: {
        color: appColors.light,
        fontFamily: appFonts.bold
    },
    tabStyle: {
        marginLeft: 20,
        marginRight: 8,
        paddingTop: 20,
        paddingBottom: 15,
        marginTop: 5,
        borderTopRightRadius: 26,
        borderTopLeftRadius: 26
    },
    tabView: {
        marginRight: 20,
        marginLeft: 8,
        paddingTop: 20,
        paddingBottom: 15,
        marginTop: 5,
        borderTopRightRadius: 26,
        borderTopLeftRadius: 26,
    },
    cardContainer: {
        borderRadius: 16,
        margin: 10,
        backgroundColor: appColors.light,
        padding: 15,

    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5,
        marginVertical: 18
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.labelColor
    },

})